/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/football_medium'
export default icon
